module.exports = __webpack_public_path__ + "static/media/vector.8bd23e0e.svg";